import BaseModelInstance from './base.model'
import { Location as ModelDefinition } from './model-definitions'

class Location extends BaseModelInstance {
  afterSet = (key, value) => {}

  constructor(attribs) {
    super(ModelDefinition, attribs)
  }
}

export default Location
